<div class="row justify-content-md-right">
    <div class="col-md-11">
        <h2 class="texto">{{header?.titleCard}} - {{header?.ScreenType}}</h2>
    </div>
    <div class="col-md-1">
        <div mat-card-avatar style="background-image: 'url(../../../assets/logoseedsview.png)'; height: 80px !important;
        width: 80px !important;" class="imageCard"></div>
    </div>
    <hr>
</div>

<br>
<div *ngIf="enableBusca">
    <app-form-sequenceManage (buildReport)="makeReport($event)"></app-form-sequenceManage>
</div>
<br>

<div class="row" *ngIf="enableReport">
    <div class="col-lg-12 col-md-12 col-xs-12 col-xl-12 col-sm-12 w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <div class="row justify-content-md-center">
                <div class="col-md-auto">
                    <p style="background-color: lightgoldenrodyellow !important;"><i class="fa fa-print"></i> Para
                        salvar em PDF, pressione Ctrl+P</p>
                </div>
            </div>

            <div class="row">
                <div class="col-lg col-md col-xs col-xl col-sm">
                    <p class="tituloLeft addTransparentBorderBottom">Dados</p>
                </div>
            </div>

            <div>
                <p><b>Site Recebimento:</b> {{selectedSite}}</p>
                <p><b>Safras:</b> {{selectedSafras}}</p>
                <p><b>Híbrido:</b> {{selectedHibrido}}</p>
                <p><b>Lotes:</b> {{selectedLotes}}</p>
                <p *ngIf="selectedPeneiras !== undefined && selectedPeneiras !== null"><b>Peneiras:</b>
                    {{selectedPeneiras}}</p>
                <p><b>Guia:</b> <a
                        href="https://bayergroup.sharepoint.com/sites/FPVideosBRZ/_layouts/15/stream.aspx?id=%2Fsites%2FFPVideosBRZ%2FShared%20Documents%2FGeneral%2FPlanta%2FSeeds%20View%2FInstru%C3%A7%C3%B5es%20Seeds%20View%20Sequ%C3%AAncia%20de%20Torre%20%2D%20vers%C3%A3o%202%2E0%2Emp4&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2Eb7300a69%2D8f27%2D460c%2Dad74%2D63bb149b5ad8"
                        target="_blank"> Veja o vídeo no BayTube para entender como foi construída essa recomendação</a>
                </p>
            </div>
            <br>

            <div class="row">
                <div class="col-lg col-md col-xs col-xl col-sm">
                    <p class="tituloLeft addTransparentBorderBottom">Relatório</p>
                </div>
            </div>

            <mat-card class="card">
                <mat-card-header>
                    <mat-card-title-group>
                    <mat-card-title>Sequências</mat-card-title>
                    </mat-card-title-group>
                </mat-card-header>
                <mat-card-content>     
                    <div *ngIf="enableVolume">
                        <p><b>Volume mínimo:</b></p>
                        <div>
                            <p>- Atenção, volume total abaixo de 150 ton, avaliar possibilidade de incluir outros lotes
                            </p>
                        </div>
                    </div>

                    <div>
                        <p><b>Sequência sugerida de contratos:</b></p>

                        <div>
                            <table mat-table [dataSource]="dataSourceByContract" class="w-100">

                                <ng-container matColumnDef="Contratos">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Contratos
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        class="formatFieldReport formatCellReport formatCellNoWrap">
                                        {{row.data.contrato_numerado}}
                                    </td>
                                </ng-container>

                                <!--ng-container matColumnDef="JanelaPlantio">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport  color-general-info"> Janela de Plantio
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'r3')">
                                        {{row.data.janela_plantio}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Ambiente">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport  color-general-info"> Ambiente
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'r3')">
                                        {{row.data.ambiente}}
                                    </td>
                                </ng-container-->

                                <ng-container matColumnDef="Volume">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Volume analisado (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{formatNoDecimals(row.data.volume_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="TotalDefeitosPonderados">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-defeitos"> Defeitos
                                            totais ponderados
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.total_defeitos_totais_ponderado)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="TotalDefeitosSeverosPonderados">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-defeitos"> Defeitos severos
                                            ponderados
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.mediana_total_defeitos_severos_ponderado)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras"> %C1
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.valor_c1_prc_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras"> %C2
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.valor_c2_prc_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras"> %C3
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.valor_c3_prc_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras"> %R1
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.valor_r1_prc_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras"> %R2
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.valor_r2_prc_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras"> %R3
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport">
                                        {{arredondarCasaDecimal(row.data.valor_r3_prc_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioPonderadoPrc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias"> Peso médio
                                        ponderado (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'c1')">
                                        {{arredondarCasaDecimal(row.data.valor_peso_medio_ponderado_pond)}}
                                    </td>
                                </ng-container>

                                <!--ng-container matColumnDef="PesoMedioC1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias"> Média de
                                        Peso médio 60M C1 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'c1')">
                                        {{arredondarCasaDecimal(row.data.valor_peso_medio_c1_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias"> Média de
                                        Peso médio 60M C2 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'c2')">
                                        {{arredondarCasaDecimal(row.data.valor_peso_medio_c2_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias"> Média de
                                        Peso médio 60M C3 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'c3')">
                                        {{arredondarCasaDecimal(row.data.valor_peso_medio_c3_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias"> Média de
                                        Peso médio 60M R1 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'r1')">
                                        {{arredondarCasaDecimal(row.data.valor_peso_medio_r1_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias"> Média de
                                        Peso médio 60M R2 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'r2')">
                                        {{arredondarCasaDecimal(row.data.valor_peso_medio_r2_pond)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias"> Média de
                                        Peso médio 60M R3 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport"
                                        [ngClass]="formatCellText(row, 'r3')">
                                        {{arredondarCasaDecimal(row.data.valor_peso_medio_r3_pond)}}
                                    </td>
                                </ng-container-->

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsByContract"></tr>
                                <tr mat-row [ngClass]="formatRowColor(row)"
                                    *matRowDef="let row; columns: displayedColumnsByContract;"></tr>

                                <!-- Row shown when there is no matching data. -->
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell text-center" colspan="100%"><i
                                            class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum
                                        registro
                                        encontrado</td>
                                </tr>
                            </table>
                        </div>

                        <br>
                        <div *ngIf="enableTipoColheita">
                            <div *ngFor="let item of listChangedTipoColheita">
                                <p>- Entre os contratos {{item.contratos}}, baixar tulha, devido à transição de
                                    {{item.tipos}};
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p><b>Sequência sugerida de lotes:</b></p>

                        <div>
                            <table mat-table [dataSource]="dataSourceByLote">
                                <ng-container matColumnDef="Contratos">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info col-8-prc"> Contratos
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        class="formatFieldReport formatCellReport formatCellNoWrap col-8-prc">
                                        {{row.data.contrato_juridico}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Silo">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info col-7-prc"> Silo
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-7-prc">
                                        {{row.data.silo_destino}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Lotes">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info col-10-prc"> Lote
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        class="formatFieldReport formatCellReport formatCellNoWrap col-10-prc"
                                        [ngClass]="formatTextColor(row) ? 'color-blue' : ''"> <b>{{row.data.lote_numerado}}</b>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Soma">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info col-7-prc"> Soma do lote total
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        class="formatFieldReport formatCellReport formatCellNoWrap col-7-prc">
                                        {{arredondarCasaDecimal(row.data.soma_lote_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="TotalDefeitosPonderados">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-defeitos size-9 col-6-prc"> Defeitos totais
                                            ponderados
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-6-prc"
                                        [ngClass]="formatCellColorDesvio5p(row, 'tabelaNaoSegregada')">
                                        {{arredondarCasaDecimal(row.data.total_defeitos_totais_ponderado)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %C1
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'c1_reprovado')">
                                        {{arredondarCasaDecimal(row.data.c1_prc)}}
                                        <span *ngIf="row.c1_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.c1_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %C2
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'c2_reprovado')">
                                        {{arredondarCasaDecimal(row.data.c2_prc)}}
                                        <span *ngIf="row.c2_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.c2_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %C3
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'c3_reprovado')">
                                        {{arredondarCasaDecimal(row.data.c3_prc)}}
                                        <span *ngIf="row.c3_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.c3_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %R1
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'r1_reprovado')">
                                        {{arredondarCasaDecimal(row.data.r1_prc)}}
                                        <span *ngIf="row.r1_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.r1_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %R2
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'r2_reprovado')">
                                        {{arredondarCasaDecimal(row.data.r2_prc)}}
                                        <span *ngIf="row.r2_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.r2_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %R3
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'r3_reprovado')">
                                        {{arredondarCasaDecimal(row.data.r3_prc)}}
                                        <span *ngIf="row.r3_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.r3_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaG1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> G1
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"> {{arredondarCasaDecimal(row.data.c1_prc +
                                        row.data.r1_prc)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaG2G3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-peneiras size-9 col-4-prc"> G2 + G3
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellGroup(row, 'g2_g3_variacao')">
                                        {{arredondarCasaDecimal(row.data.g2_g3_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                        60M C1 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_c1_variacao', 'c1')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_c1)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                        60M C2 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_c2_variacao', 'c2')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_c2)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                        60M C3 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_c3_variacao', 'c3')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_c3)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR1Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                        60M R1 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_r1_variacao', 'r1')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_r1)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR2Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                        60M R2 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_r2_variacao', 'r2')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_r2)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR3Prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                        60M R3 (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_r3_variacao', 'r3')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_r3)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioPonderadoPrc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-6-prc"> Peso médio
                                        ponderado (kg)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-6-prc"
                                        [ngClass]="formatCellText(row, 'c1')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_ponderado)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Faixas">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-medias col-10-prc"> Faixas de
                                        qualidade (*)
                                    </th>
                                    <td mat-cell *matCellDef="let row" 
                                        class="formatFieldReport formatCellReport col-10-prc"
                                        [ngClass]="formatSiloCellTextColor(row, 'HTML')">
                                        {{row.data.faixas_qual}}
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsByLote"></tr>
                                <tr mat-row [ngClass]="formatRowColor(row)"
                                    *matRowDef="let row; columns: displayedColumnsByLote;"></tr>

                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell text-center" colspan="100%"><i
                                            class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum
                                        registro
                                        encontrado</td>
                                </tr>
                            </table>
                            <div *ngIf="selectedLotesRegraSegragacao.length > 0" class="text-segregacao"><b>Beneficiar os lotes abaixo de forma segregada</b></div>
                            <table *ngIf="selectedLotesRegraSegragacao.length > 0" mat-table [dataSource]="dataSourceByLoteSegregado" class="tabela-segregados">
                                <ng-container matColumnDef="Contratos">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-general-info col-8-prc"> Contratos
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row"
                                        class="formatFieldReport formatCellReport formatCellNoWrap col-8-prc">
                                        {{row.data.contrato_juridico}}
                                </ng-container>

                                <ng-container matColumnDef="Silo">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-general-info col-7-prc"> Silo
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-7-prc">
                                        {{row.data.silo_destino}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Lotes">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-general-info col-10-prc"> Lote
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row"
                                        class="formatFieldReport formatCellReport formatCellNoWrap col-10-prc"
                                        > <b>{{row.data.lote_numerado}}</b>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Soma">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-general-info col-7-prc"> Soma do lote total
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-7-prc">
                                        {{arredondarCasaDecimal(row.data.soma_lote_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="TotalDefeitosPonderados">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-defeitos size-9 col-6-prc"> Defeitos totais
                                                ponderados
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-6-prc"
                                        [ngClass]="formatCellColorDesvio5p(row, 'tabelaSegregada')">
                                        {{arredondarCasaDecimal(row.data.total_defeitos_totais_ponderado)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC1Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %C1
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'c1_reprovado')">
                                        {{arredondarCasaDecimal(row.data.c1_prc)}}
                                        <span *ngIf="row.c1_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.c1_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC2Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %C2
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'c2_reprovado')">
                                        {{arredondarCasaDecimal(row.data.c2_prc)}}
                                        <span *ngIf="row.c2_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.c2_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaC3Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %C3
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'c3_reprovado')">
                                        {{arredondarCasaDecimal(row.data.c3_prc)}}
                                        <span *ngIf="row.c3_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.c3_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR1Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %R1
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'r1_reprovado')">
                                        {{arredondarCasaDecimal(row.data.r1_prc)}}
                                        <span *ngIf="row.r1_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.r1_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR2Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %R2
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'r2_reprovado')">
                                        {{arredondarCasaDecimal(row.data.r2_prc)}}
                                        <span *ngIf="row.r2_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.r2_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaR3Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> %R3
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellPeneirasReprovadas(row, 'r3_reprovado')">
                                        {{arredondarCasaDecimal(row.data.r3_prc)}}
                                        <span *ngIf="row.r3_teste !== ''" class="material-icons info" mat-raised-button matTooltipPosition="right"
                                            matTooltip="{{row.r3_teste}}"><img class="info" src="../../../assets/info_outline_24dp.svg">
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaG1Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras col-4-prc"> G1
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"> {{arredondarCasaDecimal(row.data.c1_prc +
                                        row.data.r1_prc)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="MediaG2G3Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-peneiras size-9 col-4-prc"> G2 + G3
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellGroup(row, 'g2_g3_variacao')">
                                        {{arredondarCasaDecimal(row.data.g2_g3_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC1Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                            60M C1 (kg)
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_c1_variacao', 'c1')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_c1)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC2Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                            60M C2 (kg)
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_c2_variacao', 'c2')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_c2)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioC3Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                            60M C3 (kg)
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_c3_variacao', 'c3')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_c3)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR1Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                            60M R1 (kg)
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_r1_variacao', 'r1')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_r1)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR2Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-media size-9s col-4-prc"> Peso médio
                                            60M R2 (kg)
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_r2_variacao', 'r2')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_r2)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioR3Prc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-4-prc"> Peso médio
                                            60M R3 (kg)
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-4-prc"
                                        [ngClass]="formatCellColor(row, 'peso_medio_r3_variacao', 'r3')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_r3)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="PesoMedioPonderadoPrc">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-medias size-9 col-6-prc"> Peso médio
                                            ponde
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellReport col-6-prc"
                                        [ngClass]="formatCellText(row, 'c1')">
                                        {{arredondarCasaDecimal(row.data.peso_medio_ponderado)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Faixas">
                                    <tr>
                                        <th mat-header-cell *matHeaderCellDef
                                            class="InputLabelHeaderColor formatFieldReport color-medias col-10-prc"> Faixas de
                                            qualidade (*)
                                        </th>
                                    </tr>
                                    <td mat-cell *matCellDef="let row" 
                                        class="formatFieldReport formatCellReport col-10-prc"
                                        [ngClass]="formatSiloCellTextColor(row, 'HTML')">
                                        {{row.data.faixas_qual}}
                                    </td>
                                    
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsByLote"></tr>
                                <tr mat-row [ngClass]="formatRowColor(row)"
                                    *matRowDef="let row; columns: displayedColumnsByLote;"></tr>

                                <!-- Row shown when there is no matching data. -->
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell text-center" colspan="100%"><i
                                            class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum
                                        registro
                                        encontrado</td>
                                </tr>
                            </table>
                        </div>
                        <br>

                        <div>
                            <div>
                                <p *ngIf="enableLegendaVermelha">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                        class="color-blue"><b>Lotes com mistura
                                            de
                                            contrato.</b> Estão sendo
                                    mostrados os valores relativos ao contrato presente no lote em maior percentual.</span>
                                </p>
                                <p *ngIf="enablePeneiraReprovada"><span class="color-red">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Peneiras reprovadas em fisiológico.</b></span></p>
                                <p mat-cell *ngIf="enableLegendaAmarela"><span
                                        class="yellowbox">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <b>&nbsp;&nbsp;Peso médio
                                        com desvio de mais de 20% em relação ao lote anterior.</b> Se os dados forem conferidos
                                    e
                                    estiverem corretos, baixar tulha entre as peneiras sinalizadas para evitar problemas de 60k
                                    sementes
                                </p>
                                <p *ngIf="enableLegendaLaranja"><span
                                        class="orangebox">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <b>&nbsp;&nbsp;Variação de
                                        mais de 15p.p. de rendimento dos grupos 2 e 3</b> somados, sugere-se reduzir a vazão da
                                    classificação
                                </p>
                                <p>&nbsp;&nbsp;&nbsp;(*)&nbsp;&nbsp;Consultar as faixas de qualidade de cada lote na tabela
                                    acima e avaliar tratativas com QP.
                                </p>
                                <p *ngIf="enableLegendaDesvio5p"><span
                                    class="pinkbox">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <b>&nbsp;&nbsp;Defeitos
                                    com desvio de mais de 5p.p.</b> Atenção às regulagens na limpeza
                                </p>
                                <p *ngIf="enablelotesSemResultadoQualidadeFisiologica">&nbsp;&nbsp;&nbsp;<span class="material-icons info-alerta">
                                    <img class="info-alerta" src="../../../assets/info_outline_24dp.svg"></span>&nbsp;&nbsp;Os lotes {{ lotesSemResultadoQualidadeFisiologica }}
                                 não possuem resultados de qualidade fisiológica. Atenção às faixas de qualidade.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="enableTempoSilo">
                        <p><b>Tempo de silo:</b></p>
                        <p>Atenção:</p>
                        <div *ngFor="let item of tempoSiloByLote">
                            <p>- lote {{item.lote_ds}} atinge o tempo máximo de silo em {{item.dias}} dias;
                            </p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="card" *ngIf="enableFundoA || enableFundoB || enableTopoA || enableTopoB || enablePeneiras || enableTubulares">
                <mat-card-header>
                    <mat-card-title-group>
                    <mat-card-title>Classificação</mat-card-title>
                    </mat-card-title-group>
                </mat-card-header>
                <mat-card-content>      
                    <div *ngIf="enableFundoA || enableFundoB || enableTopoA || enableTopoB">
                        <div *ngIf="enableFundoA || enableFundoB">
                            <p><b>Peneira de fundo:</b></p>
                            <div *ngIf="enableFundoA">
                                <p>- Rendimento das peneiras C3 e R3 abaixo de 5%, avaliar uso da peneira de fundo
                                    {{sugestedC3}} para pré-limpeza e classificação
                                </p>
                            </div>
                            <div *ngIf="enableFundoB">
                                <p>- Usar a peneira de fundo {{sugestedC3}} para pré-limpeza e classificação
                                </p>
                            </div>
                        </div>
                        <div *ngIf="enableTopoA || enableTopoB">
                            <p><b>Peneira de topo:</b></p>
                            <div *ngIf="enableTopoA">
                                <p> - Usar a peneira de topo recomendada no CD006 </p>
                                <div *ngIf="sugestedTopo !== undefined  && sugestedTopo !== null">
                                    <p> - Peneira recomendada no CD006: {{sugestedTopo}} </p>
                                </div>
                            </div>
                            <div *ngIf="enableTopoB">
                                <p> - Usar uma peneira de topo a menos que a peneira recomendada no CD006, devido à presença de
                                    sabugo* </p>
                                <div *ngIf="sugestedTopo !== undefined  && sugestedTopo !== null">
                                    <p> - Peneira recomendada no CD006: {{sugestedTopo}} </p>
                                </div>
                                <p>
                                    <i>(*) Não é recomendado usar peneira de topo abaixo da 25 para os hy: AG8780PRO3,
                                        DKB290PRO3, AG8690PRO3, 3700RR2, AS1666PRO3, DKB177PRO3, AG1051, AS1868PRO3</i>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="enablePeneiras">
                        <p><b>Peneira 18/19:</b></p>
                        <div>
                            <p>- O rendimento do grupo 3 (C3+R3) está acima de 45%. Avaliar com Qualidade e Operações se o uso
                                da peneira 18 é recomendada ao invés da peneira 19.
                            </p>
                        </div>
                    </div>
                    <div *ngIf="enableTubulares">
                        <p><b>Vazão classificação:</b></p>
                        <p>Com base no rendimento de peneiras e no número de tubulares do site, a vazão máxima recomendada para
                            evitar problemas de retenção é:</p>
                        <div *ngFor="let item of vazoesByContract">
                            <p>- Contrato {{item.contrato_juridico}}: <b>{{item.vazao}} ton/h</b> (lotes {{item.lote_ds}});
                            </p>
                        </div>
                        
                        <div *ngIf="enableSite">
                            <p><b>Qtd. tubulares sugeridos:</b></p>
                            <p>Com base no rendimento de peneiras médio dos lotes, os tubulares sugeridos para 
                                evitar problemas de retido e vazado são:</p>
                            <div>
                                <p>
                                    Peneira 21: {{vazoesByContract[0].tubulares_21}} tubulares
                                </p>
                                <p>
                                    Peneira 19/18: {{vazoesByContract[0].tubulares_19}} tubulares
                                </p>
                                <p>
                                    Peneira 16/17: {{vazoesByContract[0].tubulares_16}} tubulares
                                </p>
                                <p>
                                    Peneira 13,0ob: {{vazoesByContract[0].tubulares_13ob}} tubulares
                                </p>
                                <p>
                                    Peneira 12,5ob: {{vazoesByContract[0].tubulares_125ob}} tubulares
                                </p>
                                <p>
                                    Peneira 12,0ob: {{vazoesByContract[0].tubulares_12ob}} tubulares
                                </p>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="card" *ngIf="enableDefeitosLeves">
                <mat-card-header>
                    <mat-card-title-group>
                    <mat-card-title>Limpeza</mat-card-title>
                    </mat-card-title-group>
                </mat-card-header>
                <mat-card-content>   
                    <div *ngIf="enableDefeitosLeves">
                        <p><b>Presença de defeitos leves:</b></p>
                        <div>
                            <p>- Foi sinalizada a presença de {{tiposDefeitos}} leves no CD006 do(s) contrato(s)
                                {{contratosDefeitos}}. Verificar possibilidade de remoção nos equipamentos ou liberação especial
                                no comitê de qualidade do site, ou fórum mais apropriado.
                            </p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <div *ngIf="enableComment">
                <p><b>Observações:</b></p>
                <div *ngFor="let item of pc003">
                    <p> <span [innerHTML]="item.comment"></span> </p>
                </div>
            </div>
        </mat-card>
    </div>
</div>
